import React, { useContext, useEffect, useState } from 'react';
import { RankingContext } from '@/context/ranking';
import { makeArray } from '../../../../utils/factorys';
import { Flower } from '../../atoms/Graph/flower';
import { StateProps } from '../../atoms/interfaces';
import { BoxTooltip, Container, Control, SquareContainer } from './style';
import { TooltipContainer } from '../../atoms/Graph/tooltip';
import { ContentWrapper, Overlay } from '../ModalMap/style';

interface SquareFlowerProps {
  data: StateProps
}
export const SquareFlower: React.FC<SquareFlowerProps> = ({ data }) => {
  const [open, setOpen] = useState(false)
  return <SquareContainer onClick={() => setOpen(!open)}>
    <div className='header'>
      <p style={{ fontWeight: 900}}>{data.posicao}°</p>
      <p>{data.sigla}</p>
    </div>
    <div className='ContainerFlower'>
      <Flower isMobile petalsData={data.petals} value={data} />
    </div>
    <ContentWrapper
      open={open}
    >
      <BoxTooltip>
      <TooltipContainer isMobile data={makeArray(data?.petals)} stateInfo={data} />
      </BoxTooltip>
    </ContentWrapper>
    <Overlay open={open} onClick={() => setOpen(!open)} />

  </SquareContainer>
}
export const GraphMobile: React.FC = () => {
  const { RakingData } = useContext(RankingContext)
  const [StatesGeral, setStateGeral] = useState<StateProps[]>([])

  const { researchArea } = useContext(RankingContext)
  useEffect(() => {

    function compare(a: any, b: any) {
      if (a.posicao < b.posicao) {
        return -1;
      }
      if (a.posicao > b.posicao) {
        return 1;
      }
      return 0;
    }
    const arr = makeArray(RakingData[researchArea]?.ranking)
    arr.sort(compare);
    setStateGeral(arr)

  }, [RakingData, researchArea])

  return <Container>
    <Control>
      {
        StatesGeral.map((flow: StateProps,) => {
          return (
            <SquareFlower key={flow.sigla} data={flow} />
          )
        })
      }
    </Control>

  </Container>
}
